import type React from 'react';
import type { Frequency, CalendarIntervalType } from '../types/calendar';

export const FREQUENCY_MAP: Record<CalendarIntervalType, Frequency> = {
    weekly: 'W',
    monthly: 'M',
    quarterly: 'Q',
};

export const FIXED_COLUMNS_WIDTH_RATIO = 0.35;
export const MIN_DEFAULT_COLUMN_WIDTH = 150;
export const ACTION_COLUMN_WIDTH = 48;
export const CALENDAR_TABLE_HEIGHT_OFFSET = 450;

export const MIN_CELL_WIDTH: Record<Frequency, number> = {
    W: 150,
    M: 140,
    Q: 220,
};

export const CALENDAR_INTERVAL_OPTIONS: { label: string; value: CalendarIntervalType }[] = [
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Quarterly', value: 'quarterly' },
];

export const PROMO_STATUS_COLORS: Record<string, string> = {
    draft: '#1677FF',
    planned: '#3B82F6',
    approved: '#34D399',
    executed: '#22C55E',
};

export const PERIOD_CELL_STYLE: React.CSSProperties = {
    padding: 0,
    position: 'relative',
    overflow: 'visible',
};
